import { z } from 'zod'

import { ChecklistStatusEnum } from '@/models'

// Note: Extend possible statuses to include 'all' which will be only indicated in UI
export const ChecklistStatusExtendedEnum = z.enum([...ChecklistStatusEnum.options, 'all'])
export type ChecklistStatusExtended = z.infer<typeof ChecklistStatusExtendedEnum>
